const containers = () => {
  const articleContainer:Element|null = document.querySelector(".sb-c-content.sb-c-single-article-container")

  if (articleContainer) {
    const parentComponents:NodeListOf<HTMLElement> = document.querySelectorAll(".sb-c-single-article")
    const nextSibling:Element|null = articleContainer.nextElementSibling
    const parentContainer:ParentNode|null = articleContainer.parentNode

    parentComponents && nextSibling && parentContainer && Array.from(parentComponents).forEach((parentComponent:HTMLElement) => {
      const articleComponents:NodeListOf<Element> = parentComponent.querySelectorAll(".sb-c-content, .sb-c-header");
      Array.from(articleComponents).forEach((articleComponent:Element) => {
        parentContainer.insertBefore(articleComponent, nextSibling)
      })
    })
  }
}

export {
  containers
}
